import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useMemo } from "preact/hooks";
import Checkboxes from "./elements/Checkboxes"
import ColorFilters from "./elements/ColorFilters"
import ImageFilters from "./elements/ImageFilters"

import { filterImages } from "../config"

export default function Facet({ facet }) {
    const { active, toggleActive, toggleProductFilter } = useFacet(facet)
    const facetLabel = useMemo(() => facet.field.replaceAll('.', '-').replaceAll(' ', '-'), []) ;

    return (
        <li class="ns-facet">
            <button
                className="ns-facet__dropdown-toggle ns-w-full ns-flex ns-flex-nowrap ns-items-center ns-justify-between"
                type="button"
                data-nosto-element="facet"
                aria-controls={`ns-facet-${facetLabel}`}
                aria-label={`Expand ${facet.name} filter options`}
                aria-expanded={active}
                onClick={toggleActive}
                tabIndex="0"
            >
                <span className="ns-facet__dropdown-toggle-text">
                    {facet.name}
                </span>
                <svg class="ns-facet__dropdown-toggle-icon" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                    <path d="M56 39.671c0 0.449-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.786 0.561-1.291 0.561-0.449 0-0.954-0.224-1.291-0.561l-22.052-22.052-22.052 22.052c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z"></path>
                </svg>
            </button>
            <div
                class="ns-facet__dropdown"
                id={`ns-facet-${facetLabel}`}
                aria-hidden={!active}
                aria-labelledby={`ns-facet-heading-${facetLabel}`}
                role="region"
            >
                <div className="ns-facet__dropdown-inner">
                    <h4
                        className="visually-hidden sr-only"
                        id={`ns-facet-heading-${facetLabel}`} 
                    >
                        Filter options for {facet.name}
                    </h4>
                    {(filterImages[facet.name]) ? (
                        <ImageFilters 
                            facet={facet}
                            toggleFilter={toggleProductFilter}
                            images={filterImages[facet.name]}
                        />
                    ) : facet.name === 'Color' ? (
                        <ColorFilters
                            facet={facet}
                            toggleFilter={toggleProductFilter}
                        />
                    ) : (
                        <Checkboxes
                            facet={facet}
                            toggleFilter={toggleProductFilter}
                        />
                    )}
                </div>
            </div>
        </li>
    )
}
